const styles = (theme) => ({
  modal: {
    "& .MuiPaper-root" :{
      maxHeight:'90%',
      width:'90%'
    }
  },
  container: {
    display: "flex",
    marginTop: theme.spacing(9),
    flexDirection: "column",
    justifyContent: "space-between",
    fontFamily: "Roboto, Helvetica",
    color: "#3E3E3E",
  },
  closeButtonWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    color: "inherit",
  },
  closeButton: {
    fill: "hsla(0, 0%, 0%, 0.87)",
  },
  content: {
    display: "flex",
    flex: "2 0 auto",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "6vh",
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "1.5rem",
  },
  infoWrapper: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    gap: ".5rem",
  },
  title: {
    fontFamily: "UniNeue",
    fontSize: 20,
    fontWeight: 700,
  },
  email: {
    fontSize: 14,
  },
  avatar: {
    width: 100,
    height: 100,
    border: `2px solid ${theme.palette.primary.main}`,
  },
  button: {
    marginBlockEnd: 16,
    textTransform: "none",
    color: "#212121",
  },
  accountLink: {
    fontWeight: 700,
    cursor: 'pointer'
  },
});

export default styles;
